import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/home/Home";
import About from "../pages/about-us/About-us";
import Contact from "../pages/Contact-us/Contact-us";
import Blogs from "../pages/blogs/Blogs";
import Terms from "../pages/terms-&-conditions/Terms-&-conditions";
import Privacy from "../pages/privacy-policy/Privacy-policy";
import Error from "../pages/error-page/Error";
import View from "../components/home-page-sections/properties-section/view-all/view-all";
import PropertyDetail from "../components/property-card/detailed-property-info/detailed";
import BlogDetail from "../pages/blogs/detailed-blog-info/detailed-blog-info";
import AddProperty from "../pages/manage-your-content/add-pages/add-property";
import AddReviews from "../pages/manage-your-content/add-pages/add-reviews";
import AddButtons from "../pages/manage-your-content/manageYourContent";
import AddBlogs from "../pages/manage-your-content/add-pages/add-blogs";
import AddServices from "../pages/manage-your-content/add-pages/add-services";
import AddAboutUs from "../pages/manage-your-content/add-pages/add-AboutUs";
import AddTerms from "../pages/manage-your-content/add-pages/add-terms&cond";
import AddPriv from "../pages/manage-your-content/add-pages/add-privacy";
import AddTM from "../pages/manage-your-content/add-pages/add-teamMembers";
import AllTeam from "../components/home-page-sections/our-team/all-team/all-teamMembers";
import Login from "../components/Login-comp/login";
import PrivateRoute from "./privateRoute";
import DelProperties from "../pages/manage-your-content/delete-pages/del-prop";
import DelBlogs from "../pages/manage-your-content/delete-pages/del-blogs";

const AppRouter = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/about-us" element={<About />} />
    <Route path="/contact-us" element={<Contact />} />
    <Route path="/blogs" element={<Blogs />} />
    <Route path="/terms-conditions" element={<Terms />} />
    <Route path="/privacy-policy" element={<Privacy />} />
    <Route path="/view-all" element={<View />} />
    <Route path="/property/:id" element={<PropertyDetail />} />
    <Route path="/blog/:slug" element={<BlogDetail />} />
    <Route path="/allTeam" element={<AllTeam />} />
    <Route path="/login" element={<Login />} />
    <Route path="*" element={<Error />} />

    {/* Protected Routes */}
    <Route element={<PrivateRoute showPrompt={true} />}>
      <Route path="/manage-your-content" element={<AddButtons />} />
      <Route path="/add-property" element={<AddProperty />} />
      <Route path="/add-review" element={<AddReviews />} />
      <Route path="/add-blogs" element={<AddBlogs />} />
      <Route path="/add-services" element={<AddServices />} />
      <Route path="/add-aboutus" element={<AddAboutUs />} />
      <Route path="/add-terms" element={<AddTerms />} />
      <Route path="/add-privacy" element={<AddPriv />} />
      <Route path="/add-teamMembers" element={<AddTM />} />
      <Route path="/delete-properties" element={<DelProperties />} />
      <Route path="/delete-blogs" element={<DelBlogs />} />
    </Route>

    <Route element={<PrivateRoute showPrompt={false} />}>
      {/* You can put the route here if you want to directly redirect to Login Page without any Un-authorized access warning!!! */}
    </Route>
  </Routes>
);

export default AppRouter;
